import React from "react";
import TesteCegoRoutes from "./routes/TesteCegoRoutes";

export default function App() {
  return <TesteCegoRoutes />;
}
